import RosterItemWithSummarizedBookings from './RosterItemWithSummarizedBookings';

export default class RosterBreak extends RosterItemWithSummarizedBookings {
  constructor(start, end, hasActuals) {
    super('break', start, end, hasActuals);
  }

  overlapsWith(rosterItem) {
    return rosterItem.type === 'resourcebooking' && super.overlapsWith(rosterItem);
  }

  mustAddToSummarizedBooking(booking) {
    // We only add the booking if its start or end fall within the break
    return (
      booking.fullBookingStart.isSameOrAfter(this.start) ||
      booking.fullBookingEnd.isSameOrBefore(this.end)
    );
  }
}
